import React, { Component } from "react";

export class NotFound404 extends Component {
    render() {
        return (
            <div className={"four-zero-four-screen"}>404 Page Not Found</div>
        );
    }
}
